module.exports = __webpack_public_path__ + "static/img/share_chinese.bcaf18d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share_chinese.png
// module id = 39yj
// module chunks = 2